import { eTipoPermissao } from '@/enums/ePermissoes';

/**
 * Cópia das configurações do ano anterior — migração de MenuGestaoUsuarios/RetornoImportaEnsino.aspx.
 *
 * Permissão PRÓPRIA (2200101101), vizinha da legada (2200101100) e nunca ela: a rede libera a
 * tela nova sem mexer em quem usa a antiga. Ver docs/copia-ano-anterior/README.md.
 */
export default [
  {
    description: 'Copiar Configurações do Ano Anterior',
    path: '/administracao/copiaanoanterior',
    name: 'copia_ano_anterior',
    component: () => import('@/views/administracao/copiaanoanterior/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.COPIARENSINOEPLANOSANTERIORESNOVO_MENU_2200101101],
    },
    goesToMenu: true,
  },
];
